// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__15lGJ","title":"ClientReferral_title__3Ehx8","itemText":"ClientReferral_itemText__36Ura"};